import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";
import {useTheme} from "@mui/material";

export default (props: BaseThatsMeIconProps) => {
    const theme = useTheme()
    const {size = 24, fill= theme.palette.thatsMe.iconEclipse, ...rest} = props;
    return <svg width={size || props.width} height={size || props.height} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M24.9691 49.4799C38.4889 49.4799 49.4489 38.5199 49.4489 25C49.4489 11.4802 38.4889 0.520172 24.9691 0.520172C11.4493 0.520172 0.489258 11.4802 0.489258 25C0.489258 38.5199 11.4493 49.4799 24.9691 49.4799ZM24.9691 45.0284V23.8868V4.97052C13.9074 4.97052 4.94012 13.9378 4.94012 24.9995C4.94012 36.0612 13.9074 45.0284 24.9691 45.0284Z"
              fill={fill}/>
    </svg>
}
